export const PAGE_SIZE = 100

export const ANNOTATIONS_TYPES: { [key: string]: string } = {
  text: 'Persona',
  text_image: 'Testo e immagine',
  map: 'Mappa',
  streetview: 'Streetview',
  audio: 'Audio',
}
